global.LOGIN = "/autenticacion/login";
global.LOGINEXT = "/seguridad/login";
global.REFRESH_TOKEN = "/autenticacion/refresh_token";
global.MODULE_ACCESS = "/modulos_acceso";
global.MODULE_SUCURSAL = "/sucursales";
global.MODULE_ACCESS_OPTION = "/opciones_acceso";

// Seguridades
global.GET_ROLES = "/roles/";
global.GET_USUARIOS = "/grupos_usuarios/";
global.GET_ROLES_USUARIOS = "/usuarios/";
global.GET_TABLEROS = "/dashboard/tableros";
global.GET_AREAS = "/dashboard/areas";
global.POST_TABLEROS = "/dashboard/tableros";
global.POST_AREAS = "/dashboard/areas";
global.GET_USUARIOS2 = "/dashboard/consultar_usuarios";
global.GET_EMPRESAS = "/seguridad/empresa/consultar_empresa";
global.POST_EMPRESAS = "/seguridad/empresa/crear_empresa";
global.GET_CONFIG_USER = "/seguridad/personal/consultar_personal";
global.POST_CONFIG_USER = "/seguridad/personal/crear_personal";
global.GET_GROUP = "/seguridad/grupo_empresa/consultar_grupo_empresa";
global.POST_GROUP = "/seguridad/grupo_empresa/crear_grupo_empresa";
// BI
global.GET_AREAS_BI = "/dashboard/temas/consultar_temas_x_usuario_rol";
global.GET_TABLAS_AREAS_BI = "/dashboard/temas/consultar_tableros_x_area";
global.GET_TOKEN_BI = "/dashboard/config/obtener_access_token";

global.GET_TABLEROS_ROLE_USER =
  "/dashboard/tableros/asignar_tablero_rol_x_usuario";
global.POST_TABLEROS_ROLE_USER =
  "/dashboard/tableros/asignar_tablero_rol_x_usuario";

//logs
global.SAVE_LOGS = "/dashboard/log/crear_log";

global.GET_AI_ANSWER = "https://api-phantomx.veris.com.ec/ia/v1/aier/preguntar";
